import "@/App.css";
import { useEffect } from "react";
import axios from "axios";
import { API } from "@/lib/api";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import Landing from "@/pages/Landing";
import AuthPage from "@/pages/AuthPage";
import PayPage from "@/pages/PayPage";
import Dashboard from "@/pages/Dashboard";
import { ForgotPage, ResetPage } from "@/pages/PasswordReset";

const Loading = () => (
  <div className="terminal-bg flex items-center justify-center font-mono text-sm text-slate-500" data-testid="auth-loading">Loading…</div>
);

function Guard({ need, children }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (need === "guest") return user ? <Navigate to="/app" replace /> : children;
  if (!user) return <Navigate to="/login" replace />;
  if (need === "paid" && !user.paid) return <Navigate to="/pay" replace />;
  if (need === "unpaid" && user.paid) return <Navigate to="/app" replace />;
  return children;
}

const trackVisit = () => {
  let id = localStorage.getItem("wf-visitor");
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem("wf-visitor", id);
  }
  axios.post(`${API}/visits`, { visitor_id: id }).catch(() => {});
};

export default function App() {
  useEffect(trackVisit, []);
  return (
    <div className="dark">
      <Toaster theme="dark" position="top-right" richColors />
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Guard need="guest"><Landing /></Guard>} />
            <Route path="/login" element={<Guard need="guest"><AuthPage mode="login" /></Guard>} />
            <Route path="/register" element={<Guard need="guest"><AuthPage mode="register" /></Guard>} />
            <Route path="/forgot-password" element={<ForgotPage />} />
            <Route path="/reset-password" element={<ResetPage />} />
            <Route path="/pay" element={<Guard need="unpaid"><PayPage /></Guard>} />
            <Route path="/app" element={<Guard need="paid"><Dashboard /></Guard>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
